
(function containerTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('containerTypeService', [
            'restUrlBuilder', 'authExtend', '$q', '$filter', 'config', function containerTypeService(restUrlBuilder, auth, $q, $filter, config) {
                var that = this;
                var functionsDTypes = undefined;
                var promiseFunctionType = undefined;

                auth.onIdentityChanged(function () {
                    functionsDTypes = undefined;
                    promiseFunctionType = undefined;
                });

                this.getFunctionsDocTypes = function getFDT() {
                    if (functionsDTypes) {
                        var defered = $q.defer();
                        var promise = defered.promise;
                        defered.resolve(functionsDTypes);
                        return promise;
                    }

                    if (promiseFunctionType) {
                        return promiseFunctionType;
                    }

                    promiseFunctionType = restUrlBuilder.one('functions', config.appId() )
                        .all('containerTypes')
                        .get();

                    return promiseFunctionType;
                }

                this.getById = function getById(id, detailLevel,  functions) {
                    var params = { lod: detailLevel, function: functions };

                    return restUrlBuilder.one('containerTypes', id)
                        .get({ params: params });

                };

                this.getByDocType = function get(docTypeIds) {
                    var params = { DocumentTypeIds: docTypeIds };

                    return restUrlBuilder.all('containerTypes')
                        .get({ params: params });
                };

                this.getFunctionsTypes = function (functions) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if (!auth.isLogged()) {
                        defered.resolve([]);
                        return promise;
                    }

                    this.getFunctionsDocTypes().then(function (apiResult) {
                        functionsDTypes = apiResult;
                        var types = [];
                        functions.forEach(function (f) {
                            var results = $filter('filter')(functionsDTypes, { function: f }, true);
                            if (results.length > 0) {
                                results[0].docTypes.forEach(function (dt) {
                                    var dtr = $filter('filter')(types, { id: dt.id }, true);
                                    if (dtr.length === 0) {
                                        types.push(dt);
                                    }
                                });
                            }
                        });

                        defered.resolve(types);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }

                this.isContainertypeInRole = function (f, ctId) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.getFunctionsTypes(f).then(function (types) {
                        defered.resolve($filter('filter')(types, { id: ctId }, true).length > 0);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }


            }
        ]);

})();